import React, { useState } from 'react';
import { InfoCircleOutlined } from '@ant-design/icons';
import { Modal } from 'antd';
import InitialDetailInfo from './InitialDetailInfo';
import './index.scss';
import { WaterMark } from '@ant-design/pro-layout';
import { RootState } from '../../redux/store';
import { useSelector, useDispatch } from 'react-redux';
import { actionSendHttpRequest } from '@/redux/action';
import ActionType from '@/redux/action/common';

const VehicleInitialDetail = ({ vehicleName }: { vehicleName: string }) => {
  const [modalShow, setModalShow] = useState<boolean>(false);
  const login = useSelector((state: RootState) => state.login);
  const common = useSelector((state: RootState) => state.common);
  const { vehicleStartUpEnum } = common;
  const dispatch = useDispatch();

  return (
    <div className='vehicleInitialDetail'>
      <InfoCircleOutlined
        className='icon'
        onClick={(e: any) => {
          if (vehicleStartUpEnum.size <= 0) {
            const requestParams: HTTPFetchActionParams = {
              path: '/k2/management/vehicle_exception/vehicle_exception_get_page_list',
              method: 'POST',
              body: {
                device: '',
                module: '',
                moduleField: '',
                moduleFieldName: '',
                principalErp: '',
                pageNum: 1,
                pageSize: 300,
              },
              actionType: ActionType.VEHICLE_START_UP,
            };
            dispatch(actionSendHttpRequest(requestParams));
          }
          setModalShow(true);
        }}
      />

      <Modal
        width='1200px'
        className='vehicleInitialDetailModal'
        visible={modalShow}
        destroyOnHidden={true}
        title={'车辆初始化详情/' + vehicleName}
        footer={null}
        maskClosable={false}
        onCancel={(e: any) => {
          setModalShow(false);
        }}
      >
        <WaterMark
          content={login.user && login.user.username}
          fontColor='rgba(255,255,255,.15)'
          className='jd-warter-mark'
        >
          <InitialDetailInfo vehicleName={vehicleName} />
        </WaterMark>
      </Modal>
    </div>
  );
};

export default React.memo(VehicleInitialDetail);
